import React from "react"
import { useGetComplianceStatsQuery } from "../api/courses"
import { Row, Col } from "react-bootstrap"

const PRETTY_NAME_HASH = {
  '': 'Manually Added',
  'compliant': 'Compliant',
  'semi-compliant': 'Partially Compliant',
  'non-compliant': 'Non-Compliant'
}

const DOT_COLOR_HASH = {
  '': 'gray',
  'compliant': 'green',
  'semi-compliant': 'orange',
  'non-compliant': 'red',
}

export const CourseComplianceStats = () => {
  const { data: complianceStats } = useGetComplianceStatsQuery()

  if (!complianceStats) {
    return null;
  }

  return (
    <div>
        <span className="bold">
          {window.I18n.t("courses.compliance_status")}:
        </span>
        {Object.keys(complianceStats).map((key, index) => {
          const label = PRETTY_NAME_HASH[key] || key;
          const count = complianceStats[key];
          const dotColor = DOT_COLOR_HASH[key]
          
          return (
              <span key={`compliance-stat-${index}`}>
                <span className={`dot ${dotColor}`}/>
                 {count} {label}
              </span>
          );
        })}
    </div>
  )
}